// src/utils/backTarget.js
//
// Where a page's Back button goes (UI revamp). Pages opened from the personal
// home page get `state: { from: "home" }`; their Back then returns to /home.
// Opened any other way (the Admin Dashboard, the Coordinator page, a bookmark),
// Back goes exactly where it always did. Flag off = always the usual place.

import { UI_REVAMP_ENABLED } from "../config/featureFlags";

/** True when this page was opened from the home page. */
export const cameFromHome = (state, revamp = UI_REVAMP_ENABLED) => !!revamp && state?.from === "home";

/** { to, label } for Back: /home ("Home") when opened from home, else the page's own. */
export const backTarget = (state, to, label, revamp = UI_REVAMP_ENABLED) =>
  cameFromHome(state, revamp) ? { to: "/home", label: "Home" } : { to, label };

/**
 * State to pass to a page's own sub-pages (and back again), so a round trip
 * (Credentials → an employee → back to Credentials) keeps where it began.
 */
export const carryFrom = (state) => (state && state.from ? { from: state.from } : undefined);
